import React, { useEffect, useState } from "react";
import { message, Tooltip } from "antd";
import { CheckOutlined, CloseOutlined, EditOutlined } from "@ant-design/icons";
import { updateVisitStageStatus } from "../../../apis/patientService";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "../../../store/store";
import { patchClaimId } from "../../../models/DischargeSlice";
import {
  getPortalDataCghs,
  getPortalDataCghsNew,
  getPortalDataEchs,
  getPortalDataIhx,
  getPortalDataStarhealth,
} from "../../../models/preAuthSlice";
import { getPortalDataForAyushB } from "../../../models/ayushmanBSlice";
import { updateDraftAyushman } from "../../../apis/ayushmanBService";
import { successMessage } from "../../../utils/notificationUtils";
import { getBasicDetails } from "../../../models/patientSlice";
import { API_URL } from "../../../utils/constants";

interface ClaimIDManuallyIdProps {
  claimId?: string;
  handlePortalData?: () => void;
}

const ClaimIDManuallyId: React.FC<ClaimIDManuallyIdProps> = (props) => {
  const dispatch = useDispatch<AppDispatch>();
  const auth = useSelector((state: RootState) => state.auth);
  const getIds = useSelector((state: RootState) => state.patients);
  const { preAuth, patients, ayushBPreAuth } = useSelector(
    (state: RootState) => state,
  );
  // const [claimId, setClaimId] = useState("");
  const [claimId, setClaimId] = useState<any>(null);
  const [editClaimId, setEditClaimId] = useState(false);
  const [filledClaimId, setFilledClaimId] = useState<string | null>(null);

  const { stepperData, currentStep, stageAllState } = useSelector(
    (state: RootState) => state.preAuth,
  );

  const currentStageDetails = stepperData?.currentVisitStage;
  const currentActiveStage = stepperData?.visitStages?.[currentStep];

  const customStatus =
    currentActiveStage?.step && currentStageDetails?.step
      ? currentActiveStage.step === currentStageDetails.step
        ? currentStageDetails.state
        : currentActiveStage.step > currentStageDetails.step
          ? "Draft"
          : "Completed"
      : null;
  
  const preAuthStage = stepperData?.visitStages?.find(
    (stage: any) => stage?.visitStage === "PreAuth",
  );

  const isPreauthSubmitted =
    preAuthStage?.state === "Submitted" ||
    preAuthStage?.state === "Initiated" ||
    preAuthStage?.state === "Manually Submitted" || preAuthStage?.completed;

  const [isUpdateable, setIsUpdateable] = useState<boolean>(true);
  const [currentStatus, setCurrentStatus] = useState<string | null>(null);

  useEffect(() => {
    if (customStatus) {
      setIsUpdateable(
        customStatus?.toLocaleUpperCase() == "COMPLETED" ? false : true,
      );
      setCurrentStatus(customStatus);
    }
  }, [customStatus]);

  const handleEditClaimId = (status = true) => {
    setEditClaimId(status);
  };

  const handleClaimIdUpdate = (e: any) => {
    const { name, value } = e.target;
    if (name?.toLowerCase()?.includes("claim")) {
      setFilledClaimId(value.trim());
    }
  };

  const handleUpdateClaimIdForAyushB = async () => {
    try {
      const payload = {
        schemeMetaDataId:
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        portalMetaDataId:
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
        // casePreAuthId: store?.preAuth?.isSaveAsDraft ? preAuthId : 0,
        casePreAuthId: ayushBPreAuth?.portalData?.casePreAuthOthersResponse
          ?.casePreAuthResponse?.id
          ? ayushBPreAuth?.portalData?.casePreAuthOthersResponse
              ?.casePreAuthResponse?.id
          : 0,
        casePreAuthIhxRequest: null,
        casePreAuthCghsRequest: null,
        casePreAuthVidalRequest: null,
        casePreAuthStarhealthRequest: null,
        casePreAuthEchsRequest: null,
        casePreAuthOthersRequest: {
          claimId: filledClaimId?.trim(),
        },
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        totalAmount: "",
        claimOnPortal: true,
        action: "save",
      };
      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id &&
        ayushBPreAuth?.portalData?.id
      ) {
        const resp = await updateDraftAyushman(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          ayushBPreAuth.portalData?.id,
          payload,
        );
        successMessage("Claim Id Updated Successfully");
        handleGetData();
        dispatch(
          getBasicDetails({
            id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          }),
        );
        setEditClaimId(false);
      }
    } catch (err) {
      // handleShowDailog("Please, Try again after sometime");
    }
  };

  const handleUpdateClaimId = async () => {
    try {
      const formData = {
        registrationId: "",
        claimId: filledClaimId?.trim(),
      };
      const caseId = getIds?.fetchBasicDetails?.casesResponse?.id;
      const visitId = getIds?.fetchBasicDetails?.visitInfoResponse?.id;
      const schemeId =
        patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;

      if (
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0] ===
        "Ayushman Bharat"
      ) {
        handleUpdateClaimIdForAyushB();
      }
      else if (
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
        "CGHS AB"
      ) {
        const updatedFormData = {
          registrationId: filledClaimId?.trim(),
          claimId: filledClaimId?.trim(),
        };
        const resp = await dispatch(
          patchClaimId({
            formData: updatedFormData,
            caseId,
            visitId,
            schemeId,
          }),
        );

        if (resp.payload?.data) {
          const schemeMetaDataId =
            getIds?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;
          if (
            schemeMetaDataId &&
            [90].includes(schemeMetaDataId) &&
            props?.handlePortalData
          ) {
            props.handlePortalData();
            if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
              dispatch(
                getBasicDetails({
                  id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
                }),
              );
            }
          } else {
            handleGetData();
            if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
              dispatch(
                getBasicDetails({
                  id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
                }),
              );
            }
          }
          setEditClaimId(false);
        }
      } else {
        const resp = await dispatch(
          patchClaimId({ formData, caseId, visitId, schemeId }),
        );

        if (resp.payload?.data) {
          const schemeMetaDataId =
            getIds?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;
          if (
            schemeMetaDataId &&
            [90].includes(schemeMetaDataId) &&
            props?.handlePortalData
          ) {
            props.handlePortalData();
            if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
              dispatch(
                getBasicDetails({
                  id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
                }),
              );
            }
          } else {
            handleGetData();
            if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
              dispatch(
                getBasicDetails({
                  id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
                }),
              );
            }
          }
          setEditClaimId(false);
        }
      }
    } catch (err) {
      // handleShowDailog("Please, Try again after sometime");
    }
  };

  const handleGetData = () => {
    const caseId = getIds?.fetchBasicDetails?.casesResponse?.id;
    const visitId = getIds?.fetchBasicDetails?.visitInfoResponse?.id;
    // if (caseId && visitId) {
    //   dispatch(getPortalData({ caseId, visitId }));
    // }

    if (caseId && visitId) {
      if (
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0] ===
        "IHX"
      ) {
        dispatch(getPortalDataIhx({ caseId, visitId }));
      } else if (
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0] ===
        "CGHS"
      ) {
        dispatch(getPortalDataCghs({ caseId, visitId }));
      } else if (
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0] ===
        "CGHS AB"
      ) {
        dispatch(getPortalDataCghsNew({ caseId, visitId }));
      } else if (
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0] ===
        "ECHS"
      ) {
        dispatch(getPortalDataEchs({ caseId, visitId }));
      } else if (
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0] ===
        "STAR HEALTH"
      ) {
        dispatch(getPortalDataStarhealth({ caseId, visitId }));
      } else if (
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0] ===
        "Ayushman Bharat"
      ) {
        dispatch(getPortalDataForAyushB({ caseId, visitId }));
      }
    }
  };

  useEffect(() => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0] ===
      "Ayushman Bharat"
    ) {
      if (
        ayushBPreAuth?.portalData?.stateName === "Initiated" &&
        ayushBPreAuth?.portalData?.visitStagesName?.toLowerCase() ===
          "preauth" &&
        !(
          ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.claimId ||
          props?.claimId
        )
      ) {
        const modifiedAt = ayushBPreAuth?.portalData?.modifiedAt;
        if (modifiedAt) {
          const modifiedTime = new Date(modifiedAt).getTime();
          const now = Date.now();
          const diffSeconds = (now - modifiedTime) / 1000;

          if (diffSeconds > 78) {
            setClaimId("-");
            return;
          }

          const timeout = setTimeout(
            () => {
              setClaimId("-");
            },
            (78 - diffSeconds) * 1000,
          );

          return () => clearTimeout(timeout);
        } else {
          const timeout = setTimeout(() => {
            setClaimId("-");
          }, 150000);

          return () => clearTimeout(timeout);
        }
      } else if (
        ayushBPreAuth?.portalData?.stateName?.toLowerCase() ===
          "manually submitted" &&
        ayushBPreAuth?.portalData?.visitStagesName?.toLowerCase() ===
          "preauth" &&
        !(
          ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.claimId ||
          props?.claimId
        )
      ) {
        setClaimId("-");
      }
    }
  }, [
    ayushBPreAuth?.portalData?.stateName,
    ayushBPreAuth?.portalData?.casePreAuthCghs?.claimId,
    ayushBPreAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsReferralResponse
      ?.claimId,
    ayushBPreAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsEmergencyResponse
      ?.claimId,
    ayushBPreAuth?.portalData?.casePreAuthIhx?.claimId,
    ayushBPreAuth?.portalData?.casePreAuthStarhealth?.claimId,
    ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.claimId,
    props?.claimId,
  ]);

  useEffect(() => {
    if (
      preAuth?.portalData?.stateName === "Initiated" &&
      preAuth?.portalData?.visitStagesName?.toLowerCase() === "preauth" &&
      !(
        preAuth?.portalData?.casePreAuthCghs?.claimId ||
        preAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsReferralResponse
          ?.claimId ||
        preAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsEmergencyResponse
          ?.claimId ||
        preAuth?.portalData?.casePreAuthIhx?.claimId ||
        preAuth?.portalData?.casePreAuthStarhealth?.claimId ||
        ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.claimId ||
        props?.claimId
      )
    ) {
      const modifiedAt = preAuth?.portalData?.modifiedAt;
      if (modifiedAt) {
        const modifiedTime = new Date(modifiedAt).getTime();
        const now = Date.now();
        const diffSeconds = (now - modifiedTime) / 1000;

        if (diffSeconds > 78) {
          setClaimId("-");
          return;
        }

        const timeout = setTimeout(
          () => {
            setClaimId("-");
          },
          (78 - diffSeconds) * 1000,
        );

        return () => clearTimeout(timeout);
      } else {
        const timeout = setTimeout(() => {
          setClaimId("-");
        }, 150000);

        return () => clearTimeout(timeout);
      }
    } else if (
      preAuth?.portalData?.stateName?.toLowerCase() === "manually submitted" &&
      preAuth?.portalData?.visitStagesName?.toLowerCase() === "preauth" &&
      !(
        preAuth?.portalData?.casePreAuthCghs?.claimId ||
        preAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsReferralResponse
          ?.claimId ||
        preAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsEmergencyResponse
          ?.claimId ||
        preAuth?.portalData?.casePreAuthIhx?.claimId ||
        preAuth?.portalData?.casePreAuthStarhealth?.claimId ||
        ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.claimId ||
        props?.claimId
      )
    ) {
      setClaimId("-");
    }
  }, [
    preAuth?.portalData?.stateName,
    preAuth?.portalData?.casePreAuthCghs?.claimId,
    preAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsReferralResponse
      ?.claimId,
    preAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsEmergencyResponse
      ?.claimId,
    preAuth?.portalData?.casePreAuthIhx?.claimId,
    preAuth?.portalData?.casePreAuthStarhealth?.claimId,
    ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.claimId,
    props?.claimId,
  ]);

  useEffect(() => {
    const preAuthClaimId =
      preAuth?.portalData?.casePreAuthCghs?.claimId ??
      preAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsReferralResponse
        ?.claimId ??
      preAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsEmergencyResponse
        ?.claimId ??
      preAuth?.portalData?.casePreAuthIhx?.claimId ??
      preAuth?.portalData?.casePreAuthStarhealth?.claimId ??
      ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.claimId ??
      props?.claimId;
    if (preAuthClaimId || preAuthClaimId === "") {
      // setClaimId(
      //   preAuth?.portalData?.casePreAuthCghs?.claimId ||
      //     preAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsReferralResponse
      //       ?.claimId ||
      //     preAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsEmergencyResponse
      //       ?.claimId ||
      //     preAuth?.portalData?.casePreAuthIhx?.claimId ||
      //     preAuth?.portalData?.casePreAuthStarhealth?.claimId ||
      //     ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.claimId ||
      //     props?.claimId
      // );

      setClaimId(preAuthClaimId);

      // setClaimId(
      //   preAuth?.portalData?.casePreAuthCghs?.claimId ??
      //     preAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsReferralResponse
      //       ?.claimId ??
      //     preAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsEmergencyResponse
      //       ?.claimId ??
      //     preAuth?.portalData?.casePreAuthIhx?.claimId ??
      //     preAuth?.portalData?.casePreAuthStarhealth?.claimId ??
      //     ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.claimId ??
      //     props?.claimId
      // );
    }
  }, [preAuth?.portalData, ayushBPreAuth?.portalData, props?.claimId]);

  useEffect(() => {
    const caseId = getIds?.fetchBasicDetails?.casesResponse?.id;
    const visitId = getIds?.fetchBasicDetails?.visitInfoResponse?.id;
    const schemeMetaDataId =
      getIds?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;
    if (caseId && visitId) {
      if (
        schemeMetaDataId &&
        [90].includes(schemeMetaDataId) &&
        props?.handlePortalData
      ) {
        props.handlePortalData();
      } else {
        handleGetData();
      }
      // props?.handlePortalData ? props?.handlePortalData() : handleGetData();
    }
  }, [
    // getIds?.fetchBasicDetails?.visitInfoResponse?.id,
  ]);

  // SSE subscription for claimIdChanged events
  useEffect(() => {
    if (
      getIds?.fetchBasicDetails?.casesResponse?.id &&
      getIds?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      try {
        const caseId = getIds.fetchBasicDetails.casesResponse.id;
        const visitId = getIds.fetchBasicDetails.visitInfoResponse.id;
        const claimIdChangedUrl = `${API_URL}/api/sse/subscribe/claimIdChanged-${caseId}-${visitId}`;
        const eventSource = new EventSource(claimIdChangedUrl);

        eventSource.onmessage = (event) => {
          try {
            const data = JSON.parse(event?.data);
            setClaimId(data?.claimId);
          } catch {
            console.error("Error parsing SSE data", event?.data);
          }
        };

        eventSource.onerror = () => {
          eventSource.close();
        };

        return () => {
          eventSource.close();
        };
      } catch (error) {
        console.error(
          "Error setting up claimIdChanged SSE subscription:",
          error,
        );
      }
    }
  }, [
    getIds?.fetchBasicDetails?.visitInfoResponse?.id,
  ]);

  return (
    <>
      {(claimId ||
        (claimId === "" &&
          (preAuth?.portalData?.stateName?.toLowerCase() === "submitted" || preAuth?.portalData?.stateName?.toLowerCase()?.toString() == "id generated" || preAuth?.portalData?.stateName?.toLowerCase()?.includes("verified")))) && (
        <>
          <div className="claim-id-box" style={{ background: "#F2F6F9" }}>
            <div className="claim-id-content">
              <span
                className="claim-id-label"
                style={{ fontWeight: 400, color: "#575757" }}
              >
                CLAIM ID:{" "}
              </span>
              {!editClaimId ? (
                <span
                  style={{ fontWeight: 600, color: "black" }}
                  className="claim-id-value"
                >
                  <Tooltip title={claimId}>
                    <span style={{ fontWeight: "600", fontSize: "14px" }}>
                      {claimId
                        ? claimId?.length > 38
                          ? claimId?.substring(0, 38) + "..."
                          : claimId
                        : " "}
                    </span>
                  </Tooltip>
                </span>
              ) : (
                <input
                  type="text"
                  defaultValue={claimId}
                  name="claimId"
                  onChange={handleClaimIdUpdate}
                />
              )}

              {auth?.role?.role !== "FO_STAFF" ? (                                    //auth?.role?.role === "Mid Office Role" && !isPreauthSubmitted
                !editClaimId &&
                isUpdateable &&
                !currentStatus?.toLocaleUpperCase()?.includes("COMPLETED") ? (
                  <Tooltip title="Edit Claim ID">
                    <EditOutlined
                      style={{
                        marginLeft: "8px",
                        cursor: "pointer",
                        color: "black",
                      }}
                      onClick={() => handleEditClaimId(true)} // Fix: uncomment and enable onClick
                    />
                  </Tooltip>
                ) : (
                  isUpdateable && (
                    <>
                      <Tooltip title="CANCEL">
                        <CloseOutlined
                          style={{
                            marginLeft: "8px",
                            cursor: "pointer",
                            color: "black",
                          }}
                          onClick={() => handleEditClaimId(false)}
                        />
                      </Tooltip>
                      <Tooltip title="Save Claim ID">
                        <CheckOutlined
                          style={{ marginLeft: "8px", cursor: "pointer" }}
                          onClick={handleUpdateClaimId}
                        />
                      </Tooltip>
                    </>
                  )
                )
              ) : (
                <></>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ClaimIDManuallyId;
